import { api } from "@/api/axios.ts";
import {
  ApiEmployeeCompensation,
  ApiEmployeeCompensationPerTypes,
  ApiEmployeeCompensationSummary,
  CompensationPackageSave,
  CompensationPreview,
  ApiEmployeeCompensationPagedData,
} from "@/types/employees/employee-compensation.types.ts";
import { ApiOperationResult } from "@/types/common.types.ts";

const url = "/api/v1/employees/compensation-packages";

export const apiEmployeeCompensationPackages = {
  search(employeeId: number, pageNumber: number) {
    return api.post<ApiEmployeeCompensationPagedData>(`${url}/search`, {
      employee_ids: [employeeId],
      page_number: pageNumber,
    });
  },
  getCurrent(employeeId: number) {
    return api.get<ApiEmployeeCompensation | null>(`${url}/current/${employeeId}`);
  },
  getSummary(employeeId: number, perType: ApiEmployeeCompensationPerTypes) {
    return api.get<ApiEmployeeCompensationSummary | null>(`${url}/summary/${employeeId}`, {
      per_type: perType,
    });
  },
  create(payload: CompensationPackageSave) {
    return api.post<ApiEmployeeCompensation>(url, payload);
  },
  update(packageId: number, payload: CompensationPackageSave) {
    return api.put<ApiEmployeeCompensation>(`${url}/${packageId}`, payload);
  },
  remove(packageId: number) {
    return api.delete<ApiOperationResult>(`${url}/${packageId}`);
  },
  preview(payload: CompensationPackageSave, signal?: AbortSignal) {
    return api.post<CompensationPreview>(`${url}/preview`, payload, signal);
  },
};
